(function($){
  
  
  var getCookie = function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
        }
        return "";
    };
	var eraseCookie = function(name) {   
	  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

  
  $(document).ready(function(){
    

    // HP ribbon tooltip
	$('.grid-link__image--product').attr('style','')
    if( window.tippy ){
    	tippy('img.ribbon', {
  			content: "Exclusive Savings",
		});
    }
    
    
    // Check for clear cart cookie
    if( getCookie("orderSuccessClearCart") != ""){
		fetch("/cart/clear.json").then(function(){
          	  document.cookie = 'orderSuccessClearCart=;domain=.magazineadvantage.com;path=/';
		});
	}
    
    
    // contact us popups
    $('.mr-show-modal').click(function(e){
      e.preventDefault();
      let modal = $($(this).data('modalselector'));
      modal.css('display', 'flex');
      $('body').append(modal.detach());
      return false;
    });

    $('body').on('click', '.mr-modal .close, .mr-modal .btn-close', function(e){
      e.preventDefault();
      $(this).parents('.mr-modal').hide();
      return false;
    });  
    // end contact us popups
    
    $('.magazine-offer').click(function(e){
    	$(this).find('input[type=radio]').prop('checked',true);
    	$('.magazine-offer').removeClass('selected');
        $(this).addClass('selected');      
    });
    
    var lightbox = new SimpleLightbox('.product-single-thumbnails a', { /* options */ });
    
    
  });

    window.fetchJson = function (url,data, method){
        return fetch(url, {method: method || 'POST', headers: {"Content-Type": "application/json"}, body: JSON.stringify(data)});
    };

  
  window.MA = window.MA || {};
  
  
      MA.initUpsellModal = function(){
    
    // upsell popup
    let productForm = $('form[action="/cart/add"]');
	let modal = $('.magazine-modal');
        
        
	let gatherItemLines = function(){
    	let lines = [{
        	id: $('input[name="id[]"]:checked').val(),
            quantity: 1,
            selling_plan: $('input[name=selling_plan]').val()
        }];
      return lines;
	};
    
        
    /* modal add /checkout button */
    $('.magazine-modal .actions').on('click', 'button',function(){

		lines = gatherItemLines();
      
        if( $(this).is('.btn-add') ){
            $(modal).find('.product.active').each( function(){
                lines.push({
                    id: $(this).data("variant"),
                    quantity: 1,
                    selling_plan: $(this).data("sellingplan")
                });
            })
        }

        fetch("/cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ items: lines })
        }).then(function(){ window.location.href = "/cart"; });
    });
    
        
    /* 1 item per cart */
	$('.launch-checkout').click(function(e){
	    e.preventDefault(); 
       fetch("/cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ items: gatherItemLines() })
        }).then(function(){ window.location.href = "/checkout"; });
      return false;
	});
        
        
    /* multi-item cart w/ addon modal */
	$('.launch-magazine-modal').click(function(e){
      e.preventDefault();
      	if( MA.allProducts ){
          e.preventDefault();
	      modal.find('.products-container > .product').remove();


          let selectedOffer = $('.magazine-offer.selected');
          let selectedSku = selectedOffer.data('sku').split("-");
		  let selectedPrice = selectedOffer.data('price');
          $(modal).find('.item-price').html( selectedPrice );
          
    	  for( var i = 0; i < MA.allProducts.length; i++){

            
            if( MA.allProducts[i].id == MA.currentProductId ){
              modal.find('.selected-name').html( MA.allProducts[i].title );
            } else {

              for( var j = 0; j < MA.allProducts[i].variants.length; j++){
                let sku = MA.allProducts[i].variants[j].sku.split("-");
                let skuPrice = MA.allProducts[i].variants[j].price / 100;
                
                console.log(selectedPrice);
                console.log( skuPrice );console.log("---");
                if( selectedSku[1] == sku[1] && selectedSku[2] == sku[2] && selectedPrice.replace("$","") == skuPrice ){
                    console.log(MA.allProducts[i].variants[j]);
                    let newProduct = $('<div class="product" data-sellingplan="'+MA.allProducts[i].variants[j].selling_plan_allocations[0].selling_plan_id+'" data-product="'+MA.allProducts[i].id+'" data-variant="'+ MA.allProducts[i].variants[j].id +'"><img src="'+ MA.allProducts[i].images[0] +'" alt="' + MA.allProducts[i].title + '"/></div>');
                    for( var k = 0; k < MA.allProducts[i].tags.length; k++){
                      newProduct.addClass("tag-" + MA.allProducts[i].tags[k]);
                    }
	           		modal.find('.products-container').append(newProduct);              
                }
              }
            }
          }
          
    	 modal.show();
         return false;
      	}
      return true;
    });
        
    modal.on('click', '.product', function(){
      	$(this).toggleClass('active');
    });
    
    modal.find('.close, .btn-close').click(function(e){
      e.preventDefault();
      modal.hide();
      return false;
    })
    /* end upsell popup */
    };
      
      
  MA.initSubscriptionPage = function(){
    let endpoint = "https://account.magazineadvantage.com/api/create-checkout";

	var createCheckoutSession = function(cb) {
	fetch("/cart.json").then(function(result){
		return result.json();
	}).then( function(data){
      
		let items = [];
		for( var i = 0; i < data.items.length; i++ ){
          items.push({
            variant: data.items[i].variant_id,
            quantity: data.items[i].quantity,
            sku: data.items[i].sku,
            gift: (data.items[i].properties && data.items[i].properties["Type"] && data.items[i].properties["Type"] == "Gift Subscription")});
		}

  		fetch(endpoint, {
  			  method: "POST",
   			 headers: {
    		  "Content-Type": "application/json"
   			 },
          body: JSON.stringify({site: window.location.host, attributes: data.attributes, items: items, aid: getCookie("aid")})
  			})
		    .then(function(result) {
			      return result.json();
		    })
		    .then(function(data) {
				if( data.success ){
			    	cb(data);
				} else {
					alert(data.error);
				}
		    });
    });
      
  };

      
      $('.btn-init-checkout').click(function(e){
      e.preventDefault();
      createCheckoutSession(function(data){
			window.location.href = data.url;
      })
      return false;
      })
    
    
    
  };
  


    
    

})(jQuery);